import React from "react";
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';

const ProgressBar = ({percentage}) => {
  

  return (
    <div className="progress-bar">
      <CircularProgressbar
        value={percentage}
        text={`${percentage}%`}
        strokeWidth= {5}
        styles={buildStyles({
          textSize: '16px',
          pathTransitionDuration: 0.5,
          pathColor: `rgba(62, 152, 199,1)`,
          textColor: '#f88',
          trailColor: '#ccc',
          
          backgroundColor: `linear-gradient(to right, #4CAF50, #2196F3)`,
        })}
      />
    </div>
  );
};

export default ProgressBar;